module.exports = "<gfx-ged [config]=\"gedConfig\"></gfx-ged>"